import * as React from "react";

import Box from "@mui/material/Box";

import { neutral } from "app/themes/colors";

/** Small key cap — the launcher's footer legend and the shortcuts guide. */
export default function KeyCap({ children }: { children: React.ReactNode }) {
  return (
    <Box
      component="kbd"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: 20,
        height: 20,
        px: 0.75,
        borderRadius: 0.75,
        border: `1px solid ${neutral[300]}`,
        backgroundColor: neutral[50],
        color: neutral[700],
        fontFamily: "inherit",
        fontSize: 11,
        fontWeight: 600,
        lineHeight: 1
      }}
    >
      {children}
    </Box>
  );
}
